import LoadingIndicator from 'components/loading-indicator';
import LoadableVisibility from 'components/loadable-visibility';
import { ReactNode } from 'react';

export default (loader, loading: ReactNode = LoadingIndicator) =>
  LoadableVisibility({ loader, loading });
